import React from "react"
import {connect} from "react-redux"
import {PersonInfoModal} from "module/PersonInfo/component/PersonInfoModal";
import {createSelector} from 'reselect';
import {PersonAttr} from 'module/selpan/impl/person/model/PersonUtil';

const selHeader = createSelector(
	state => state.PersonInfo.PIModal.persNr,
	state => state.Person.byId,
	(persNr, byId) => {
		const person = byId[persNr];
		return PersonAttr.getStringRepresentation(person)
	},
);

const mapState = (state) => {
	if (!state.PersonInfo || !state.PersonInfo.PIModal) return {open: false}; //optional
	const {persNr, date} = state.PersonInfo.PIModal;
	return {
		open: Boolean(persNr),
		persNr,
		date,
		header: selHeader(state),
	};
};

export const PersonInfoModalContainer = connect(mapState)(PersonInfoModal);